<template>
  <section class="faq" ref="rootEl">
    <div class="accordion">
      <div class="accordion__item" v-for="(item, i) in items" :key="`accordion-item-${i}`">
        <div :class="generateQuestionClasses(i)" @click="makeActive(i)">
          <p class="accordion__question-text hover-anime--color-2" v-html="item[questionProperty]"></p>
          <button :class="generateButtonClasses(i)"></button>
        </div>

        <collapse-transition>
          <div v-if="i === activeQuestionIndex">
            <div
              class="accordion__answer nested-copy--18px-l nested-copy--fw3-l nested-copy--0-4px-l nested-copy--lh-34px-l nested-copy--b nested-copy--link-underline hover-color--color-2"
              v-html="item[answerProperty]"
            ></div>
          </div>
        </collapse-transition>
      </div>
    </div>
  </section>
</template>

<script>
import { CollapseTransition } from "vue2-transitions"

export default {
  name: "FaqAccordion",
  components: {
    CollapseTransition
  },
  data() {
    return {
      activeQuestionIndex: null //
    }
  },
  props: {
    /**
     * Array of items
     * Object style {questionProperty: string, answerProperty: string, tabName: string}
     * You can change object keys names using other props (questionProperty, answerProperty, tabName)
     */
    items: {
      type: Array,
      required: true
    },
    /**
     * Key name of object in items array for specifying title of question
     */
    questionProperty: {
      type: String,
      default: "question"
    },
    /**
     * Key name of object in items array for specifying content text of open question
     */
    answerProperty: {
      type: String,
      default: "answer"
    },
    /**
     * Color for hover and active tab/question
     * possible values: 'red', '#F00', 'rgb(255, 0, 0)'
     */
    activeColor: {
      type: String,
      default: "#D50000"
    },
    /**
     * Color for borders
     */
    borderColor: {
      type: String,
      default: "#9E9E9E"
    },
    /**
     * Color for fonts
     */
    fontColor: {
      type: String,
      default: "#000000"
    }
  },
  methods: {
    makeActive(itemIndex) {
      this.activeQuestionIndex === itemIndex
        ? (this.activeQuestionIndex = null)
        : (this.activeQuestionIndex = itemIndex)
    },
    generateButtonClasses(buttonIndex) {
      return [
        "accordion__toggle-button",
        this.activeQuestionIndex === buttonIndex
          ? "accordion__toggle-button--active"
          : null
      ]
    },
    generateQuestionClasses(questionIndex) {
      return [
        "accordion__question",
        this.activeQuestionIndex === questionIndex
          ? "accordion__question--active"
          : null
      ]
    }
  }
}
</script>
